module.exports = __webpack_public_path__ + "img/chevron-bar-up.b231d47f.svg";